module.exports = __webpack_public_path__ + "c95931428e4b9db0cd355dbab24560be.pdf";